import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectIsStockError } from '../reducers/uiSlice'
import StoreUtils from '../utils/storeUtils'
import PaymentGateways from '../strategy/payment/constants'
import { useTranslation } from 'react-i18next'

const useStockErrors = (store) => {
  const [stockErrorMessages, setStockErrorMessages] = useState({
    stockErrorText: '',
    stockErrorTextTwo: '',
  })
  const { t } = useTranslation()
  const [paymentGateway] = StoreUtils.getPaymentGateways(store)
  const isStockError = useSelector(selectIsStockError)

  useEffect(() => {
    if (paymentGateway.type === PaymentGateways.TIENDA_NUBE) {
      setStockErrorMessages({
        stockErrorText: t('checkout.stockErrorTN'),
        stockErrorTextTwo: t('checkout.stockErrorTNTwo'),
      })
    }
    if (paymentGateway.type === PaymentGateways.ESSEN_ECOMMERCE) {
      setStockErrorMessages({
        stockErrorText: t('checkout.stockErrorEssen'),
        stockErrorTextTwo: t('checkout.stockErrorEssenTwo'),
      })
    }
    // Sin esta rama el cartel de stock de Linx se renderiza VACÍO: isStockError es true
    // pero los dos textos quedan en '', así que el comprador ve el ícono de error y el
    // botón sin una sola palabra. Está medido que la tienda no recorta la cantidad --
    // descarta el agregado completo-- así que el comprador no puede seguir con ese SKU.
    if (paymentGateway.type === PaymentGateways.LINX) {
      setStockErrorMessages({
        stockErrorText: t('checkout.stockErrorLinx'),
        stockErrorTextTwo: t('checkout.stockErrorLinxTwo'),
      })
    }
  }, [])

  return {
    isStockError,
    stockErrorText: stockErrorMessages.stockErrorText,
    stockErrorTextTwo: stockErrorMessages.stockErrorTextTwo,
  }
}

export default useStockErrors
